import Types from '../Types'
import Immutable from 'seamless-immutable'
import { createReducer } from 'reduxsauce'
import Cookies from 'js-cookie'
import { get } from 'lodash'

export const INITIAL_STATE = Immutable({
  error: null,
  findAttempting: false,
  users: [],
  findOneAttempting: false,
  user: {},
  findWishlistAttempting: false,
  wishlist: [],
  pageCount: 0,
  loginAttempting: false,
  me: {},
  loginError: false,
  signupAttempting: false,
  signupAttempted: false,
  verifyAttempting: false,
  forgotPasswordAttempting: false,
  forgotPasswordAttempted: false,
  setNewPasswordAttempting: false,
  setNewPasswordAttempted: false,
  saveAttempting: false,
  saveAttempted: false,
  giveaways: [],
  findGiveawaysAttempting: false,
  findGiveawaysAttempted: false
})

const ACTION_HANDLERS = {
  [Types.FIND_USERS_ATTEMPT]: (state, action) =>
    state.merge({ findAttempting: true }),
  [Types.FIND_USERS_SUCCESS]: (state, action) =>
    state.merge({
      findAttempting: false,
      users: get(action, ['result', 'users']) || [],
      pageCount: get(action, ['result', 'pageCount']) || 0,
      error: null
    }),
  [Types.FIND_USERS_FAILURE]: (state, action) =>
    state.merge({ listAttempting: false, error: action.error }),

  [Types.FIND_ONE_USER_ATTEMPT]: (state, action) =>
    state.merge({ findOneAttempting: true, user: {} }),
  [Types.FIND_ONE_USER_SUCCESS]: (state, action) =>
    state.merge({ findOneAttempting: false, user: action.result, error: null }),
  [Types.FIND_ONE_USER_FAILURE]: (state, action) =>
    state.merge({ findOneAttempting: false, error: action.error }),

  [Types.FORGOT_PASSWORD_ATTEMPT]: (state, action) =>
    state.merge({ forgotPasswordAttempting: true, forgotPasswordAttempted: false }),
  [Types.FORGOT_PASSWORD_SUCCESS]: (state, action) =>
    state.merge({ forgotPasswordAttempting: false, forgotPasswordAttempted: true, error: null }),
  [Types.FORGOT_PASSWORD_FAILURE]: (state, action) =>
    state.merge({ forgotPasswordAttempting: false, forgotPasswordAttempted: false, error: action.error }),

  [Types.LOGIN_ATTEMPT]: (state, action) =>
    state.merge({ loginAttempting: true, loginError: false }),
  [Types.LOGIN_SUCCESS]: (state, action) => {
    Cookies.set('token', action.result.token, { expires: 7 })
    window.location.reload()
    return state.merge({ loginAttempting: false, me: action.result.user, error: null, loginError: false })
  },
  [Types.LOGIN_FAILURE]: (state, action) =>
    state.merge({ loginAttempting: false, error: action.error, loginError: true }),

  [Types.LOGOUT_ATTEMPT]: (state, action) =>
    state.merge({ logoutAttempting: true }),
  [Types.LOGOUT_SUCCESS]: (state, action) => {
    Cookies.remove('token')
    window.location.reload()
    return state.merge({ logoutAttempting: false, me: undefined, error: null })
  },
  [Types.LOGOUT_FAILURE]: (state, action) =>
    state.merge({ logoutAttempting: false, error: action.error }),

  [Types.SET_NEW_PASSWORD_ATTEMPT]: (state, action) =>
    state.merge({ setNewPasswordAttempting: true, setNewPasswordAttempted: false }),
  [Types.SET_NEW_PASSWORD_SUCCESS]: (state, action) =>
    state.merge({ setNewPasswordAttempting: false, setNewPasswordAttempted: true, error: null }),
  [Types.SET_NEW_PASSWORD_FAILURE]: (state, action) =>
    state.merge({ setNewPasswordAttempting: false, setNewPasswordAttempted: false, error: action.error }),

  [Types.EDIT_PROFILE_ATTEMPT]: (state, action) =>
    state.merge({ editProfileAttempting: true, editProfileAttempted: false }),
  [Types.EDIT_PROFILE_SUCCESS]: (state, action) =>
    state.merge({ editProfileAttempting: false, editProfileAttempted: true, me: action.result, error: null }),
  [Types.EDIT_PROFILE_FAILURE]: (state, action) =>
    state.merge({ editProfileAttempting: false, editProfileAttempted: false, error: action.error }),

  [Types.SAVE_USER_ATTEMPT]: (state, action) =>
    state.merge({ saveAttempting: true, saveAttempted: false }),
  [Types.SAVE_USER_SUCCESS]: (state, action) =>
    state.merge({ saveAttempting: false, saveAttempted: true, user: action.result, error: null }),
  [Types.SAVE_USER_FAILURE]: (state, action) =>
    state.merge({ saveAttempting: false, saveAttempted: false, error: action.error }),

  [Types.REMOVE_USER_ATTEMPT]: (state, action) =>
    state.merge({ removeAttempting: true, removeAttempted: false }),
  [Types.REMOVE_USER_SUCCESS]: (state, action) =>
    state.merge({
      removeAttempting: false,
      removeAttempted: true,
      users: state.users.filter(user => user.userId !== action.result.userId)
    }),
  [Types.REMOVE_USER_FAILURE]: (state, action) =>
    state.merge({
      removeAttempting: false,
      removeAttempted: false,
      error: action.error
    }),

  [Types.SIGNUP_ATTEMPT]: (state, action) =>
    state.merge({ signupAttempting: true, signupAttempted: false }),
  [Types.SIGNUP_SUCCESS]: (state, action) =>
    state.merge({ signupAttempting: false, signupAttempted: true, error: null }),
  [Types.SIGNUP_FAILURE]: (state, action) =>
    state.merge({ signupAttempting: false, signupAttempted: false, error: action.error }),

  [Types.VERIFY_ATTEMPT]: (state, action) =>
    state.merge({ verifyAttempting: true }),
  [Types.VERIFY_SUCCESS]: (state, action) =>
    state.merge({ verifyAttempting: false, me: action.result, error: null }),
  [Types.VERIFY_FAILURE]: (state, action) =>
    state.merge({ verifyAttempting: false, error: action.error }),

  [Types.ADD_TO_CART_SUCCESS]: (state, action) =>
    state.merge({ me: state.me.merge({ cartOrderId: get(action, 'result.orderId') }) }),

  [Types.FIND_WISHLIST_ATTEMPT]: (state, action) =>
    state.merge({ findWishlistAttempting: true }),
  [Types.FIND_WISHLIST_SUCCESS]: (state, action) =>
    state.merge({
      findWishlistAttempting: false,
      wishlist: action.result.wishlist,
      pageCount: action.result.pageCount,
      error: null
    }),
  [Types.FIND_WISHLIST_FAILURE]: (state, action) =>
    state.merge({ findWishlistAttempting: false, error: action.error }),

  [Types.ADD_TO_WISHLIST_ATTEMPT]: (state, action) =>
    state.merge({ addToWishlistAttempting: true }),
  [Types.ADD_TO_WISHLIST_SUCCESS]: (state, action) =>
    state.merge({
      addToWishlistAttempting: false,
      wishlist: state.wishlist.concat([action.result]),
      error: null
    }),
  [Types.ADD_TO_WISHLIST_FAILURE]: (state, action) =>
    state.merge({
      addToWishlistAttempting: false,
      error: action.error
    }),

  [Types.REMOVE_FROM_WISHLIST_ATTEMPT]: (state, action) =>
    state.merge({ removeFromWishlistAttempting: true }),
  [Types.REMOVE_FROM_WISHLIST_SUCCESS]: (state, action) =>
    state.merge({
      removeFromWishlistAttempting: false,
      wishlist: state.wishlist.filter(({ productCode }) => productCode !== action.result.productCode),
      error: null
    }),
  [Types.REMOVE_FROM_WISHLIST_FAILURE]: (state, action) =>
    state.merge({
      removeFromWishlistAttempting: false,
      error: action.error
    }),

  [Types.FIND_GIVEAWAYS_ATTEMPT]: (state, action) =>
    state.merge({ findGiveawaysAttempting: true }),
  [Types.FIND_GIVEAWAYS_SUCCESS]: (state, action) =>
    state.merge({
      findGiveawaysAttempting: false,
      giveaways: action.result.giveaways,
      error: null
    }),
  [Types.FIND_GIVEAWAYS_FAILURE]: (state, action) =>
    state.merge({ findGiveawaysAttempting: false, error: action.error }),

  [Types.REORDER_SUCCESS]: (state, action) =>
    state.merge({ me: { ...state.me, cartOrderId: get(action, ['result', 0, 'orderId']) } }),
  [Types.GET_CART_SUCCESS]: (state, action) =>
    state.merge({ me: { ...state.me, cartOrderId: get(action, 'result.cart.orderId') } }),
  [Types.CHECKOUT_SUCCESS]: (state, action) =>
    state.merge({ me: { ...state.me, cartOrderId: action.cartOrderId } }),

  [Types.SET_INITIAL]: (state, action) => state.merge(INITIAL_STATE)
}

export default createReducer(INITIAL_STATE, ACTION_HANDLERS)



// WEBPACK FOOTER //
// ./src/redux/user/userReducer.js